import Vue from 'vue';

export class FullscreenController {
  constructor(documentRef = document) {
    this.document = documentRef;
    this.root = null;
    this.state = Vue.observable({ supported: false, active: false, error: null });
    this.handleChange = this.handleChange.bind(this);
  }

  mount(root) {
    this.root = root;
    this.state.supported = Boolean(root && root.requestFullscreen && this.document.exitFullscreen);
    if (this.state.supported) this.document.addEventListener('fullscreenchange', this.handleChange);
    this.handleChange();
  }

  handleChange() {
    this.state.active = Boolean(this.root && this.document.fullscreenElement === this.root);
  }

  async toggle() {
    if (!this.state.supported) throw new Error('Fullscreen API is unavailable');
    this.state.error = null;
    try {
      if (this.state.active) await this.document.exitFullscreen();
      else await this.root.requestFullscreen();
      this.handleChange();
    } catch (error) {
      this.state.error = error;
      this.handleChange();
      throw error;
    }
  }

  unmount() {
    if (this.state.supported) this.document.removeEventListener('fullscreenchange', this.handleChange);
    this.root = null;
  }
}
